/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { TypesPortalsOptions } from 'services/types_portals';
import InputMask from 'react-input-mask';
import { useDispatch, useSelector } from 'react-redux';
import { savePortal, updatePortal } from 'store/modules/portals_manager_store/actions';
import SquareLoader from 'components/atoms/square_loader';
import { ApplicationState } from 'store';
import { PortalsManagerState, PortalsTypes } from 'store/modules/portals_manager_store/types';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';
import { ProfileState } from 'store/modules/profile_store/types';
import companyId from 'services/company_id';
import { Container } from './styles';

interface CreateAccessFormProps {
  source: string;
  portal?: PortalsTypes | null;
  setAction?: React.Dispatch<React.SetStateAction<string>> | undefined;
}

const PortalFormAccess = (props: CreateAccessFormProps) => {
  const { source, portal, setAction } = props;
  const dispatch = useDispatch();
  const [name, seName] = useState<string>('');
  const [url, setUrl] = useState<string>('');
  const [cpf, setCpf] = useState<string>('');
  const [type, setType] = useState<number>(0);
  const [login, setLogin] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [expirationDate, setExpirationDate] = useState<string>('');

  const { request } = useSelector<ApplicationState, PortalsManagerState>(
    (state) => state.session.portals_manager,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const formData = {
      name,
      url,
      cpf,
      category_id: type,
      login,
      codigo: code,
      login_expiration_date: expirationDate,
    };

    if (source === 'view') {
      setAction?.('edit');
    } else if (source === 'edit' && portal?.id) {
      const company = companyId(profile);
      dispatch(updatePortal(portal.id, formData, company));
      createTrack('Gerenciar Portais - Editou um acesso salvo');
    } else {
      dispatch(savePortal(formData, companyId(profile)));
      createTrack('Gerenciar Portais - Salvou um novo acesso');
      track('gerenciar_portais.salvou_novo_acesso');
    }
  };

  useEffect(() => {
    seName('');
    setUrl('');
    setCpf('');
    setType(0);
    setLogin('');
    setCode('');
    setExpirationDate('');
  }, [request?.save_portal?.loaded]);

  useEffect(() => {
    if (portal && (source === 'edit' || source === 'view')) {
      seName(portal.name || '');
      setUrl(portal.url || '');
      setCpf(portal.cpf || '');
      setType(portal.category_id || 0);
      setLogin(portal.login || '');
      setCode(portal.codigo ? atob(portal.codigo) : '');
      setExpirationDate(portal.login_expiration_date || '');
    }
  }, [source, portal]);

  return (
    <Container onSubmit={handleSubmit}>
      <div className="form-row">
        <div className={`form-group ${source === 'add' ? 'col-md-4' : 'col-md-6'}`}>
          <label htmlFor="portalName" className="mb-0">
            Nome do portal
          </label>
          <input
            type="text"
            className="form-control"
            id="portalName"
            value={name}
            onChange={(e) => seName(e.target.value)}
            placeholder="Digite o nome do portal"
            required
            disabled={source === 'view'}
          />
        </div>
        <div className={`form-group ${source === 'add' ? 'col-md-3' : 'col-md-6'}`}>
          <label htmlFor="cpf" className="mb-0">
            CPF (opcional)
          </label>
          <InputMask
            mask="999.999.999-99"
            className="form-control"
            id="cpf"
            value={cpf}
            placeholder="Digite o cpf"
            onChange={(e) => setCpf(e.target.value)}
            disabled={source === 'view'}
          />
        </div>
        <div className={`form-group ${source === 'add' ? 'col-md-4' : 'col-md-12'}`}>
          <label htmlFor="url" className="mb-0">
            URL (opcional)
          </label>
          <input
            type="text"
            className="form-control"
            id="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Digite a url do portal"
            disabled={source === 'view'}
          />
        </div>
        <div className={`form-group ${source === 'add' ? 'col-md-1' : 'col-md-6'}`}>
          <label htmlFor="type" className="mb-0">
            Tipo
          </label>
          <Select
            name="types"
            id="type"
            closeMenuOnSelect
            options={TypesPortalsOptions}
            noOptionsMessage={() => 'Nenhuma opção'}
            placeholder="Tipo"
            value={TypesPortalsOptions.find((option) => option.value === type) || null}
            onChange={(selected) => setType(selected?.value || 0)}
            isDisabled={source === 'view'}
          />
        </div>
        <div className={`form-group ${source === 'add' ? 'col-md-4 mb-0' : 'col-md-6'}`}>
          <label htmlFor="expirationDate" className="mb-0">
            Data de vencimento do login
          </label>
          <input
            type="date"
            className="form-control"
            id="expirationDate"
            value={expirationDate}
            placeholder="Senha"
            onChange={(e) => setExpirationDate(e.target.value)}
            disabled={source === 'view'}
          />
        </div>
        <div className={`form-group ${source === 'add' ? 'col-md-3 mb-0' : 'col-md-6'}`}>
          <label htmlFor="login" className="mb-0">
            Login
          </label>
          <input
            type="text"
            className="form-control"
            id="login"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            placeholder="Digite o login"
            required
            disabled={source === 'view'}
          />
        </div>
        <div
          className={`form-group position-relative ${
            source === 'add' ? 'col-md-4 mb-0' : 'col-md-6'
          }`}
        >
          <label htmlFor="password" className="mb-0">
            Senha
          </label>
          <input
            type={showPassword ? 'text' : 'password'}
            className="form-control"
            id="password"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Digite a senha"
            required
            disabled={source === 'view'}
          />
          <button
            type="button"
            className="btn position-absolute show-password p-0 m-0"
            tabIndex={0}
            onClick={() => setShowPassword(!showPassword)}
            title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
          >
            <i className="material-icons">{showPassword ? 'visibility_off' : 'visibility'}</i>
          </button>
        </div>
        <div
          className={`form-group mb-0 ${
            source === 'add' ? 'col-md-1 d-flex align-items-end' : 'col-md-12'
          }`}
        >
          {request?.save_portal?.loading ? (
            <div className="position-relative d-inline-block px-3">
              Salvando
              <SquareLoader customClass="solicited-edital-loading" />
            </div>
          ) : (
            <button type="submit" className="btn btn-block btn-primary btn-sm p-2">
              {source === 'edit'
                ? 'Salvar edição'
                : source === 'view'
                ? 'Editar acesso'
                : 'Salvar acesso'}
            </button>
          )}
        </div>
      </div>
    </Container>
  );
};

export default PortalFormAccess;
